import React from 'react';
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

const Pagination = ({ currentPage, totalPages, setCurrentPage, totalEntries, entriesPerPage }) => {
    const startEntry = ((currentPage - 1) * entriesPerPage) + 1;
    const endEntry = Math.min((currentPage - 1) * entriesPerPage + entriesPerPage, totalEntries);

    return (
        <div className="flex items-center justify-between mt-4">
            <div className="text-sm text-gray-500">
                {totalEntries > 0
                    ? `Showing ${startEntry} to ${endEntry} of ${totalEntries} entries`
                    : 'No entries to show'
                }
            </div>
            <div className="flex items-center gap-2">
                <Button
                    variant="outline"
                    size="icon"
                    onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                    disabled={currentPage === 1}
                >
                    <ChevronLeft className="w-4 h-4" />
                </Button>
                <span className="text-sm">
                    Page {currentPage} of {totalPages}
                </span>
                <Button
                    variant="outline"
                    size="icon"
                    onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                    disabled={currentPage === totalPages}
                >
                    <ChevronRight className="w-4 h-4" />
                </Button>
            </div>
        </div>
    );
};

export default Pagination;